import { BaseComponent } from "../../../BaseComponent";
import * as Glob from "../../../../Globale";
import * as Dati from "../../../../Dati";
import { Trad } from "../../../Trad";
import * as React from "react";
import { ConfirmModal } from "../../../../helpers/ModalHelper";

interface IFileList {
    Files: Glob.DatiJSON;
    OnRemove: (file: Dati.CDocumentExtended) => void;
    OnDownloadFile: (document: Dati.CDocumentExtended) => void;
    AddEnabled?: boolean;
    URLDownload?: string;
}

export class DocumentList extends BaseComponent<IFileList, {}> {
    public constructor(props: any) {
        super(props);
    }

    private Remove(File: Dati.CDocumentExtended) {
        ConfirmModal("Are You sure You want to delete file?", "Remove")
            .then((value: boolean) => {
                if (value) {
                    this.props.OnRemove(File);
                }
            });
    }

    private getFileList(): any {
        if (this.props.Files == undefined)
            return <div></div>;

        let Files: Dati.CDocumentExtended[] = [];
        if (typeof (this.props.Files) == "string")
            Files = JSON.parse(this.props.Files);
        else
            Files = this.props.Files;

        let Result: any[] = [];
        for (let i: number = 0; i < Files.length; i++) {

            let icon: string = "";
            if (Files[i].MIME != undefined && Files[i].MIME == "application/doc")
                icon = "./assets/metronic/media/files/doc.svg"
            else if (Files[i].MIME != undefined && Files[i].MIME == "application/pdf")
                icon = "./assets/metronic/media/files/pdf.svg"
            else if (Files[i].MIME != undefined && (Files[i].MIME == "image/jpeg" || Files[i].MIME == "image/png"))
                icon = "./assets/metronic/media/files/jpg.svg"
            else
                icon = "";

            let URLDownload: string = this.props.URLDownload == undefined ? "/api/Document" : this.props.URLDownload;

            let Remove: any = null;
            let Edit = <a href={URLDownload + "?sessione=" + Glob.GetSessione().Sessione + "&id_Document=" + Files[i].ID_Document} target="_blank" className="kt-widget4__title file-name">
                {Files[i].Description ? Files[i].Description : Files[i].DownloadFileName}
            </a>;

            if (this.props.AddEnabled != undefined && this.props.AddEnabled) {
                Remove = <a onClick={() => this.Remove(JSON.parse(JSON.stringify(Files[i])))} className="btn btn-sm btn-label-danger btn-bold">{Trad.Trad("Rimuovi")}</a>;
                Edit = <a onClick={() => this.props.OnDownloadFile(Files[i])} className="kt-widget4__title file-name">
                    {Files[i].Description ? Files[i].Description : Files[i].DownloadFileName}
                </a>;
            }

            Result.push(<div className="kt-widget4__item" key={"File_" + i.toString()}>
                <div className="kt-widget4__pic kt-widget4__pic--icon">
                    <a href={URLDownload + "?sessione=" + Glob.GetSessione().Sessione + "&id_Document=" + Files[i].ID_Document}>
                        <img src={icon} alt="" />
                    </a>
                </div>
                {Edit}
                {Remove}
            </div>);
        }

        return Result;
    }

    render() {
        return this.getFileList()
    }
}


// WEBPACK FOOTER //
// ./src/components/custom/Document/DocumentBox/DocumentList.tsx